import React, { useState, useEffect } from "react";
import * as deviceService from "../../devices/deviceService";
import SSHAlgorithmField from "./SSHAlgorithmField"
import ChooseDeviceField from "./ChooseDeviceField";
import { ChevronDown } from 'lucide-react';


export default function AdditionalSSHAlgorithmOptionsSection() {

  const initialState = {
    sshAlgorithm: '',
    selectedDevice: null,
  }

  const [state, setState] = useState(initialState);
  const [devices, setDevices] = useState([]);
  const [collapsed, setCollapsed] = useState(true);

  const fetchData = async () => {
    try {
      const deviceList = await deviceService.list();
      const devices = deviceList.filter(device => device.connectionType === 'SSH');
      setDevices(devices);
      // const configFilesList = await configChangesService.getConfigFiles();
      // setConfigFiles(configFilesList);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onDeviceChange = (value, sshAlgorithm) => {
    setState({
      ...state,
      selectedDevice: value,
      sshAlgorithm: sshAlgorithm,
    });
  }

  const onAlgorithmChange = (value) => {
    setState({
      ...state,
      sshAlgorithm: value
    });
  };

  return (
    <>
      <button
        className="oct_settings-section-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <h3>Additional SSH Algorithm Options</h3>
        <ChevronDown className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}/>
      </button>

      <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
        <p className="oct_settings-description">
          This settings should be used to update Algorithm Options of a device!
        </p>

        <ChooseDeviceField devices={devices} value={state.selectedDevice} onChange={onDeviceChange} />
        <SSHAlgorithmField value={state.sshAlgorithm} device={state.selectedDevice} onChange={onAlgorithmChange} />
      </div>
    </>
  );
}
